var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[(_vm.chartData)?_c('commitChart',{attrs:{"chartData":_vm.chartData,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }